import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { api } from "@/lib/api";
import { resetTourCache } from "@/lib/tourState";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

// Route pubbliche (portale condòmino / pratica pubblica): niente chiamate autenticate.
const isPublicPath = () => {
  const p = window.location.pathname;
  return p === "/portal" || p.startsWith("/p/") || p.startsWith("/c/") || p === "/verifica-email" || p === "/reset-password";
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Se stiamo tornando dal callback OAuth, lascia gestire ad AuthCallback
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    // Su route pubbliche non serve verificare la sessione (evita 401 in console)
    if (isPublicPath()) {
      setUser(false);
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.debug("logout failed", e); }
    try { resetTourCache(); } catch { /* noop */ }
    setUser(false);
    window.location.href = "/login";
  }, []);

  const value = useMemo(() => ({ user, setUser, loading, checkAuth, logout }), [user, loading, checkAuth, logout]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
